import React from 'react';
import { TrophyOutlined, CrownOutlined } from '@ant-design/icons';

function RankBadge({ rank }) {
  if (rank == null || isNaN(rank)) return <span>-</span>;
  const r = Number(rank);
  if (r === 1) {
    return (
      <span style={{ color: '#FFD700', fontWeight: 'bold' }}>
        <CrownOutlined /> {r}
      </span>
    );
  }
  if (r === 2) {
    return (
      <span style={{ color: '#FFB347', fontWeight: 'bold' }}>
        <TrophyOutlined /> {r}
      </span>
    );
  }
  if (r === 3) {
    return (
      <span style={{ color: '#FF6B6B', fontWeight: 'bold' }}>
        <TrophyOutlined /> {r}
      </span>
    );
  }
  if (r <= 10) {
    return <span style={{ color: '#4ECDC4', fontWeight: 'bold' }}>{r}</span>;
  }
  return <span>{r}</span>;
}

export default RankBadge;
